import { Ajax } from "../../Common/Ajax";
import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";

export class BuyPointAnalysis {
    private static readonly REPORT_DATE = '#closingDate';
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

        private init() {
            $(BuyPointAnalysis.GRID).kendoGrid({
                dataSource: {
                    transport: {
                        read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_WEBSITE_BUYPOINT_ANALYSIS
                    },
                },
                dataBound: () => {
                    const data: any = $(BuyPointAnalysis.GRID).data('kendoGrid')!.dataSource.data();
                    if (data && data.length > 0) {
                        $(BuyPointAnalysis.REPORT_DATE).html(
                            HtmlHelpers.getFormattedDate(data[0].closingDate));
                    }
                },

                height: 915,
                groupable: false,
                sortable: true,
                pageable: false,
                detailInit: this.openDetail,
                columns: [{
                    field: 'symbol',
                    title: 'Symbol',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '20%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-left' },
                }, {
                    field: 'bigCap20',
                    title: 'BigCap20',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'sectorLeader',
                    title: 'SectorLeaders',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'ipoLeader',
                    title: 'IpoLeaders',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'spotlight',
                    title: 'Spotlight',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'incomeInvestor',
                    title: 'IncomeInvestor',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'listCount',
                    title: 'List<br>Count',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }]
        });
    }
    private openDetail(e: any) {
        const urlSuffix = GlobalData.URL_SUFFIX_IBD_WEBSITE_BUYPOINT_ANALYSIS +
            '/Detail?symbol=' + e.data.symbol;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = () => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }
}
